import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Breadcrumbs from "components/views/Breadcrumbs";
import ProgressCircle from "components/views/atoms/ProgressCircle";

const Wrapper = styled.div`
  .Breadcrumbs {
    padding: 0 ${({ theme }) => theme.spacer * 1.5}px;
    background-color: ${({ theme }) => theme.palette.grey.lightest};

    ${({ theme }) => theme.mediaQueries.medium} {
      padding: 0px ${({ theme }) => theme.spacer * 4}px;
    }
  }
`;
const Heading = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.background.grey};
  padding: ${({ theme }) => theme.spacer}px
    ${({ theme }) => theme.spacer * 1.5}px;

  ${({ theme }) => theme.mediaQueries.medium} {
    padding: ${({ theme }) => theme.spacer}px
      ${({ theme }) => theme.spacer * 4}px;
  }

  .ProgressCircle {
    margin-right: ${({ theme }) => theme.spacer}px;
    font-size: 3.5rem;
    ${({ theme }) => theme.mediaQueries.medium} {
      font-size: 5.2rem;
    }
  }
  h2 {
    ${({ theme }) => theme.resFontSize.large};
    margin: 0;
  }
`;

const ProgressHeading = ({ className, perc, heading, breadcrumbSteps }) => {
  const classes = ["ProgressHeading"];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(" ")}>
      <Heading>
        <ProgressCircle perc={perc} />
        <h2>{heading}</h2>
      </Heading>

      <Breadcrumbs steps={breadcrumbSteps} />
    </Wrapper>
  );
};

ProgressHeading.displayName = "ProgressHeading";

ProgressHeading.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string.isRequired,
  perc: PropTypes.number.isRequired,
  breadcrumbSteps: Breadcrumbs.propTypes.steps,
};

ProgressHeading.defaultProps = {
  className: null,
  breadcrumbSteps: [],
};

export default ProgressHeading;
